import { AuthPageProps, withAuth } from '../../context/Auth';
import withContainer from '../../components/Container/withContainer';
import { getCourses, deleteCourses } from '../../api/courses/courses';
import { CourseInfo } from '../../api/courses/courses.types';
import { ColumnProps, TableTranslateColumns } from '../../ui/Table';
import { PowerTable } from 'ui/PowerTable';
import { RouterPaths } from 'helpers/router-paths';
import { useCallback } from 'react';
import { userOrganizationId } from 'api/organizations/organizations.mapper';
import { OrganizationType } from 'api/api';
import {
    DeleteWordsTuple,
    PowerTableGetter
} from 'ui/PowerTable/PowerTable.types';

const COURSES_COLUMNS: ColumnProps<CourseInfo> = {
    title: {
        title: 'Название курса',
        width: 500
    },
    trainingType: {
        title: 'Вид обучения',
        width: 150
    },
    organizationTitle: {
        title: 'Организация',
        width: 400
    },
    hoursCount: {
        title: 'Объём часов',
        width: 150
    },
    issuedDocuments: {
        title: 'Выдаваемый документ',
        width: 250
    },
    price: {
        title: 'Стоимость',
        width: 150
    }
};

const translateColumns: TableTranslateColumns<CourseInfo> = {
    assignedQualification: 'qualificationTypes',
    issuedDocuments: 'issuedDocuments',
    trainingType: 'trainingTypes'
};

const deleteWords: DeleteWordsTuple = ['курсов', 'курс', 'курса'];

const CoursesList = ({ user }: AuthPageProps) => {
    const getter: PowerTableGetter<CourseInfo> = useCallback(
        ({ search }) =>
            getCourses(
                { search },
                user.operator?.organization?.organizationType ===
                    OrganizationType.EducationCenter
                    ? userOrganizationId(user)
                    : undefined
            ),
        [user]
    );

    return (
        <PowerTable
            columns={COURSES_COLUMNS}
            translateColumns={translateColumns}
            getter={getter}
            linkGetter={RouterPaths.SingleCourse}
            onDelete={deleteCourses}
            noRowsMsg="Курсы не найдены"
            deleteWords={deleteWords}
        />
    );
};

export default withAuth(
    withContainer(CoursesList, {
        heading: 'Список курсов',
        flex: true
    })
);
